import {BrandedFooter} from '@components/branding';
import {CenterContainer} from '@screens/review-section3/styles';
import * as React from 'react';
import {ISection2DocumentUploadStore} from '@stores/onboarding-review/section2-document-upload-store';
import {useTranslation} from '@utils/cache-translations';
import {Title} from '@screens/review-section2/document-upload/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {AsyncOkModal} from '@services/AsyncModals';
import {DocumentSeeInstructionsModal} from '@screens/review-section2/document-upload/document-see-instructions-modal';
import {createConfigurationValuesService} from '@services/factories';
import {observer} from 'mobx-react';
import {IConfigurationValuesService} from '@services/ConfigurationValuesService';
import I9DocumentUploadV1Wrapper from '@screens/review-section2/document-upload/v2/I9DocumentUploadV1Wrapper';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import dayjs from 'dayjs';
import DayjsUtils from '@date-io/dayjs';
import {OnConfirmType} from '@models/onConfirm-type';
import { isNil } from 'lodash';

interface Props {
    store: ISection2DocumentUploadStore;
    onConfirm: OnConfirmType;
    onUseOtherDocuments?: () => void;
    isReceiptUpload?: boolean;
}

const useStyles = makeStyles(() => ({
    root: {
        padding: 5
    },
    header: {
        flexDirection: 'column',
        marginTop: 10
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
        height: '100%'
    },
    scrollContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflowY: 'scroll'
    },
    dashedDivider: {
        marginTop: 10,
        width: '100%',
        borderBottom: '2px dashed rgba(0, 0, 0, 0.3)'
    },
    seeInstructions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 8,
        marginBottom: 16,
        fontWeight: 'bold',
        color: '#106ba3',
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    solidDivider: {
        width: '100%',
        borderBottom: '2px solid rgba(0, 0, 0, 0.1)'
    },
    notesContainer: {
        maxWidth: '800px',
        '&>div': {
            margin: '8px 0'
        }
    }
}));

const I9DocumentUploadPage = observer(({store, onConfirm, onUseOtherDocuments, isReceiptUpload}: Props) => {
    const css = useStyles();
    const translations = useTranslation('i9DocumentUpload');
    const configurationValuesService: IConfigurationValuesService = createConfigurationValuesService();

    const seeMore = async () => {
        await AsyncOkModal({
            title: translations.get('requiredDocumentsTitle'),
            message: <DocumentSeeInstructionsModal/>,
            confirmLabel: translations.get('okButton')
        })
    };

    return (
        <div className={css.scrollContainer}>
            <CenterContainer fillAvailable={true}>
                <div className={css.root}>
                    <div className={css.header}>
                        <Title>
                            
                            {
                            // @ts-ignore
                            !isNil(store?.i9StatusDetails?.i9Section2Status) && store?.i9StatusDetails?.i9Section2Status === 'RECEIPT_REPLACEMENT' ?
                              translations.get('receiptDocumentAddLabel') : translations.get('title')}
                        </Title>
                        <div>
                            {translations.get('documentInfo')}
                        </div>
                        <div className={css.seeInstructions} onClick={seeMore}>
                            {translations.get('documentRequirementInstructions')}
                        </div>
                        <div className={css.solidDivider}/>
                        {
                            configurationValuesService.showExtraUploadInstructions &&
                            <div className={css.notesContainer}>
                                <div>
                                    {translations.get('documentNote1')}
                                </div>
                                <div>
                                    {translations.get('documentNote2')}
                                </div>
                                <div>
                                    {translations.get('documentNote3')}
                                </div>
                            </div>
                        }
                    </div>
                    <MuiPickersUtilsProvider utils={DayjsUtils} locale={dayjs.locale()} libInstance={dayjs}>
                        <I9DocumentUploadV1Wrapper
                            store={store}
                            workStatus={store.workStatus}
                            onConfirm={onConfirm}
                            onUseOtherDocuments={onUseOtherDocuments}
                            isReceiptUpload={isReceiptUpload}
                        />
                    </MuiPickersUtilsProvider>
                </div>
            </CenterContainer>
            <BrandedFooter/>
        </div>
    );
});

export default I9DocumentUploadPage;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/document-upload-page.tsx